@use "assets/styles/abstracts/variables" as v;

.app {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}
